import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiUser } from 'react-icons/fi';
import { AppContext } from '../../context/AppContext';
import useAuth from '../../hooks/useAuth';
import NotificationBell from './NotificationBell';
import Brand from './Brand';
import './Header.css';

const Header = () => {
  const { toggleSidebar } = useContext(AppContext);
  const { user, logout } = useAuth();

  return (
    <header className="header">
      <div className="header__left">
        <button 
          className="header__menu-btn" 
          onClick={toggleSidebar}
          aria-label="Toggle navigation menu"
        >
          <FiMenu />
        </button>
        <Link to={user ? '/dashboard' : '/'} className="header__brand">
          <Brand />
        </Link>
      </div>
      <div className="header__right">
        {user ? (
          <div className="header__user-menu">
            <NotificationBell />
            <span className="header__user-name">{user.first_name}</span>
            <button onClick={logout} className="header__logout-btn" aria-label="Log out">
              Logout
            </button>
          </div>
        ) : (
          <Link to="/login" className="header__login-link">Login</Link>
        )}
      </div>
    </header>
  );
};

export default Header;
